export const SHOW_MODAL = 'modals/SHOW_MODAL';
export const HIDE_MODAL = 'modals/HIDE_MODAL';
export const CLEAR_MODAL = 'modals/CLEAR_MODAL';
